/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

  document.querySelectorAll('.production-information .points .point').forEach((point) => {
        point.addEventListener("click" , (event, target) => {
          document.querySelector('.production-information .points .point.active').classList.remove("active");
            event.target.classList.add("active");
            let block = `[data-block="`+event.target.getAttribute("data-block")+`"]`;
            document.querySelector('.production-information .info-blocks li.active').classList.remove("active");
            document.querySelector('.production-information .info-blocks li'+block).classList.add("active");
        });
    });
  document.querySelectorAll('.additional-information .points .point').forEach((point) => {
        point.addEventListener("click" , (event, target) => {
          document.querySelector('.additional-information .points .point.active').classList.remove("active");
            event.target.classList.add("active");
            let block = `[data-block="`+event.target.getAttribute("data-block")+`"]`;
            document.querySelector('.additional-information .info-blocks li.active').classList.remove("active");
            document.querySelector('.additional-information .info-blocks li'+block).classList.add("active");
        });
    });

// custom recharge js
  let custom_selling_plan_options = document.querySelector('.custom-selling-plan-options');
  let rechargeRadio = document.querySelectorAll('[name="purchaseOption"]');
  if(rechargeRadio.length > 0){
    for (var i = 0; i < rechargeRadio.length; i++) {
        rechargeRadio[i].addEventListener('change', function() {
          if(document.getElementById("trialProduct") != null ){
            if(this.value == 'subscription'){
             document.querySelector('[data-product-select]').setAttribute("name","id");
             document.querySelector('[name="selling_plan"]').value = document.querySelector('input[name="planDuration"]:checked').value;
              if(document.querySelector('[name="properties[delivery]"]') != null){
                document.querySelector('[name="properties[delivery]"]').value = document.querySelector('input[name="planDuration"]:checked').getAttribute("data-name").split(" - ")[1];
              }
           }else {
             custom_selling_plan_options.style.display = 'none';
             document.querySelector('[name="selling_plan"]').value = '';
              if(document.querySelector('[name="properties[delivery]"]') != null){
                document.querySelector('[name="properties[delivery]"]').value = '';
              }
           }
          } else {
           if(this.value == 'subscription'){
             document.querySelector('.qty_forsubscription').disabled = false;
             if(document.querySelector(".product-addon") != null){
               document.querySelector(".product-addon").style.display = "block";
             }
             document.querySelector('.qty_forsubscription').style.display = 'block';
             document.querySelector('.custom_rechargeqty').style.display = 'block';
             document.querySelector('.qty_foronetime').style.display = 'none';
             document.querySelector('#main .product__info .product-form .quantity-selector input').value = document.querySelector('.qty_forsubscription').value;
             // document.querySelector('.product-addon').style.display = "none";
             // document.querySelector('.product-addon input').checked = false;
             document.querySelector('[data-product-select]').setAttribute("name","id");
             document.querySelector('[name="selling_plan"]').value = document.querySelector('input[name="planDuration"]:checked').value;
             
           } else if(this.value == 'box'){
             if(document.querySelector(".product-addon") != null){
               document.querySelector(".product-addon").style.display = "none";
               document.querySelector('#addoProduct--input').checked = false;
             }
             custom_selling_plan_options.style.display = 'none';
             document.querySelector('.qty_forsubscription').style.display = 'block';
             document.querySelector('.qty_foronetime').style.display = 'none';
             document.querySelector('.qty_forsubscription').selectedIndex = 0;
             document.querySelector('.qty_forsubscription').disabled = true;
             document.querySelector('.qty_forsubscription').style.display = 'none';
             document.querySelector('.custom_rechargeqty').style.display = 'none';
             document.querySelector('#main .product__info .product-form .quantity-selector input').value = document.querySelector('.qty_forsubscription').value;
             document.querySelector('[name="selling_plan"]').value = '';
             
           } else {
             if(document.querySelector(".product-addon") != null){
               document.querySelector(".product-addon").style.display = "none";
               document.querySelector('#addoProduct--input').checked = false;
             }
             custom_selling_plan_options.style.display = 'none';
             document.querySelector('.qty_forsubscription').style.display = 'none';
             document.querySelector('.qty_foronetime').style.display = 'block';
             document.querySelector('.custom_rechargeqty').style.display = 'block';
             document.querySelector('#main .product__info .product-form .quantity-selector input').value = document.querySelector('.qty_foronetime').value;
             // document.querySelector('.product-addon').style.display = "block";
             document.querySelector('[name="selling_plan"]').value = ''
           }
          }
        });
    }
  }
  let rechargeDurationRadio = document.querySelectorAll('[name="planDuration"]');
  if(rechargeDurationRadio.length > 0){
    for (var i = 0; i < rechargeDurationRadio.length; i++) {
        rechargeDurationRadio[i].addEventListener('change', function() {
           document.querySelector('[name="selling_plan"]').value = this.value;
          document.querySelector('#subscription_option_lbl .option-selling-plan-lbl').innerHTML = this.getAttribute('data-name');
          if(document.querySelector('#addoProduct--input') != null ){
            document.querySelector('#addoProduct--input').setAttribute("data-selling-plan",document.querySelector(".product-addon-sellingPlans option[data-name='"+this.getAttribute('data-name')+"']").value);
          }
        });
    }
  }
let rechargeDurationOption = document.querySelector('.option-selling-plan-sub');
if(document.querySelector('.option-selling-plan-sub') != null){
 rechargeDurationOption.addEventListener('click', function() {
    if (custom_selling_plan_options.style.display === "none") {
      this.classList.add = 'option-selling-plan-active';
      custom_selling_plan_options.style.display = 'block';
    } else {
      this.classList.remove = 'option-selling-plan-active';
      custom_selling_plan_options.style.display = 'none';
    }
  });
}
let rechargeSelect = document.querySelectorAll('.custom_rechargeqty select');
if(rechargeSelect.length > 0){
for (var i = 0; i < rechargeSelect.length; i++) {
    rechargeSelect[i].addEventListener('change', function() {
      document.querySelector('#main .product__info .product-form .quantity-selector input').value = this.value;
    });
}
}
// if(document.querySelector('#addoProduct--input') != null ){
// document.querySelector('#addoProduct--input').addEventListener('change', function(event){
//   if (event.target.checked) {
//     document.querySelector('[data-product-select]').setAttribute("name","id[]")
//   } else {
//     document.querySelector('[data-product-select]').setAttribute("name","id")
//   }
// })
// }

let hashTags = document.querySelectorAll('a');
if (hashTags.length > 0) {
    for (var i = 0; i < hashTags.length; i++) {
        hashTags[i].addEventListener('click', function(event) {
            const href = event.target.href;
            if (href.indexOf('#') !== -1 && !href.includes('#smile-home')) {
                event.preventDefault(); // Prevent default anchor behavior

                // Split the URL by the hash
                const ele = href.split(/#/);

                // Find the element by the hash (ID) value
                const element = document.querySelector('#' + ele[1]);

                // Check if the element exists
                if (element) {
                    const topPos = (element.getBoundingClientRect().top + window.pageYOffset) -
                                   (document.getElementById('shopify-section-header').offsetHeight);

                    // Scroll smoothly to the element's position
                    window.scrollTo({
                        top: topPos, // scroll so that the element is at the top of the view
                        behavior: 'smooth' // smooth scroll
                    });
                }
            }
        });
    }
}
let home_img_with_txt = document.querySelectorAll('.home_img-with-txt');
if(home_img_with_txt.length > 0){
window.addEventListener("scroll",function(){
    let windowOffsety = this.pageYOffset;
    home_img_with_txt.forEach(function(el){
        let elTop = el.offsetTop - 130;
        let elHeight = el.offsetTop + el.offsetHeight - 130;
        if(windowOffsety > elTop && windowOffsety < elHeight){
            el.classList.add("animated")
        }else{
           el.classList.remove("animated") 
        }
    })
})
}
const urlParams = new URL(window.location.toLocaleString()).searchParams;
const param = urlParams.get('click_id');
document.cookie = "retracking_cilick_id="+param+"; expires=Thu, 18 Dec 2013 12:00:00 UTC; path=/";
   // document.querySelectorAll("input[name='purchaseOption']").forEach((input) => {
   //      input.addEventListener('change', function(event){
   //          if(event.target.value == "onetime"){
   //              document.querySelector('.product-addon').style.display = "block";
   //              document.querySelector('[name="selling_plan"]').value = ''
   //          }else{
   //              document.querySelector('.product-addon').style.display = "none";
   //              document.querySelector('.product-addon input').checked = false;
   //              document.querySelector('[data-product-select]').setAttribute("name","id");
   //          }
   //      });
   //  });

  function checkPassword(str)
{
    var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    return re.test(str);
}
// if(document.getElementById("register-customer") !=  null){
//   document.getElementById("register-customer").addEventListener("submit",function(e) { 
//        console.log(document.getElementById('customer-password').value);
//      var PasswordValid = checkPassword(document.getElementById('customer-password').value);
//       if (PasswordValid) {
//         console.log("valid password");
//         document.getElementById("register-form-password-error").style.display = "none";
      
//       } else {
//         console.log("Invalid password")
//         document.getElementById("register-form-password-error").style.display = "flex";
//         document.getElementById("register-form-submit").removeAttribute("aria-busy");
//         e.preventDefault(); // stops our form from submitting
//       }
//   });
// }
function passwordEye(target,field) {
  var x = document.getElementById(field);
  if (x.type === "password") {
      target.classList.add("active");
    x.type = "text";
  } else {
    x.type = "password";
      target.classList.remove("active");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  // console.log("Hello World!");
  if(window.location.hash != ''){
    const element = document.querySelector(window.location.hash);
    const topPos = (element.getBoundingClientRect().top + window.pageYOffset) -(document.getElementById('shopify-section-header').offsetHeight + 25);
    window.scrollTo({
      top: topPos, // scroll so that the element is at the top of the view
      behavior: 'smooth' // smooth scroll
    })
  }
});
document.querySelector(".header__icon-currencyMobOutter").addEventListener('click', function(){
document.getElementsByClassName("wgcurrent")[1].click()
})
document.querySelector(".header__icon-wrapper1.header__icon-langMob .lang-icon-mob > span").addEventListener('click', function(){
setTimeout(function(){
document.querySelectorAll(".header__icon-wrapper1 .doubly-nice-select")[1].click()
},100);
})
document.querySelector(".header__icon-wrapper1.header__icon-langMob .lang-text > svg").addEventListener('click', function(){
setTimeout(function(){
document.querySelectorAll(".header__icon-wrapper1 .doubly-nice-select")[1].click()
},100);
})
if(document.querySelector(".blog-load-more button") != null){
  document.querySelector(".blog-load-more button").addEventListener('click',function(){
      document.querySelectorAll(".article-list .article-item:not(.active)").forEach(function(item){
      item.classList.add("active");
  })
      event.target.classList.add("hide");
  })
}
    window.addEventListener('scroll', function() {
        const supportButton = document.getElementById('launcher');
        const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrolled = window.scrollY;

        if (scrolled >= scrollableHeight) {
            supportButton.style.bottom = '90px';
        } else {
            supportButton.style.bottom = '0px';
        }
    });
// document.addEventListener("DOMContentLoaded", () => {
//   const tooltipTrigger = document.querySelector(".box-option-info-tooltip");

//   tooltipTrigger.addEventListener("click", () => {
//     tooltipTrigger.classList.toggle("active");
//   });

//   document.addEventListener("click", (e) => {
//     if (!tooltipTrigger.contains(e.target)) {
//       tooltipTrigger.classList.remove("active");
//     }
//   });
// });

//added by Parcely app 
 
    // waitForElm('#checkout').then((elm) => {
    // 	elm.style.display = 'none';
    // });
    
    
     waitForElm('.parcely_app').then(() => {
        const parcelMethodDivs = document.querySelectorAll('.parcely_app_shipping_method');
        const cartElement = document.querySelector('[data-cart-weight]');
        const checkoutButton = document.getElementById('checkout');
        const weightRestrictionError = document.querySelector('.weightRestrictionError');
        const errorContent = weightRestrictionError.querySelector('.banner__content');
    
        parcelMethodDivs.forEach((div) => {
            div.addEventListener('click', () => {
                const radioButton = div.querySelector('.parcelyRadio');
    
                if (radioButton) {
                    const textElement = div.querySelector('span');
    
                    if (textElement) {
                        console.log(`Selected option: ${textElement.textContent.trim()}`);
    
                        if (cartElement && checkoutButton && weightRestrictionError && errorContent) {
                            const cartWeight = parseFloat(cartElement.getAttribute('data-cart-weight'));
    
                            if (!isNaN(cartWeight)) {
                                const selectedOption = textElement.textContent.trim();
                                let weightLimit = 0;
                                let errorMessage = '';
                                if (cartWeight > 31 && selectedOption === 'Delivery by courier') {
                                    weightLimit = 31;
                                    errorMessage = `Your order is more than ${weightLimit}KG - Please contact customer support`;
                                } else if (cartWeight > 24 && selectedOption === 'Delivery to locker or pick-up point') {
                                    weightLimit = 24;
                                    errorMessage = `Your order is more than ${weightLimit}KG - Please contact customer support`;
                                }

                                if (weightLimit) {
                                    // Add error classes and update the message
                                    if (!checkoutButton.classList.contains('weightRestrictionbtn')) {
                                        checkoutButton.classList.add('weightRestrictionbtn');
                                    }
                                    if (!weightRestrictionError.classList.contains('weightRestrictionErrorShow')) {
                                        weightRestrictionError.classList.add('weightRestrictionErrorShow');
                                    }
                                    errorContent.textContent = errorMessage;
                                } else {
                                    // Remove error classes
                                    if (checkoutButton.classList.contains('weightRestrictionbtn')) {
                                        checkoutButton.classList.remove('weightRestrictionbtn');
                                    }
                                    if (weightRestrictionError.classList.contains('weightRestrictionErrorShow')) {
                                        weightRestrictionError.classList.remove('weightRestrictionErrorShow');
                                    }
                                }
                            }
                        }
                    }
                }
            });
        });
    });

    
    function waitForElm(selector) {
      return new Promise(resolve => {
          if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
          }

          const observer = new MutationObserver(mutations => {
              if (document.querySelector(selector)) {
                  resolve(document.querySelector(selector));
                  observer.disconnect();
              }
          });

          observer.observe(document.body, {
              childList: true,
              subtree: true
          });
      });
	}

//added by Parcely app

// document.addEventListener('DOMContentLoaded', () => {
//     const checkoutButton = document.getElementById('checkout');
// console.log("hbhj")
//     if (checkoutButton) {
//         checkoutButton.addEventListener('click', (event) => {
//             // Prevent default behavior of the first click
//             event.preventDefault();

//             // Trigger a second click after a short delay
//             setTimeout(() => {
//                 checkoutButton.click();
// console.log("hdsdbhj")
              
//             }, 50); // Adjust the delay if necessary
//         });
//     }
// });
document.addEventListener("DOMContentLoaded", () => {
  const shippingPointDay = document.querySelector('.shipping-point-day');
  const currentLanguage = Weglot.getCurrentLang();
  console.log('Current Language:', currentLanguage);
  if(shippingPointDay){
    if(currentLanguage == 'lv' || currentLanguage == 'en'){
      shippingPointDay.innerHTML = '1 - 3'
    } else if(currentLanguage == 'pl'){
      shippingPointDay.innerHTML = '2 - 5'
    } else {
      shippingPointDay.innerHTML = '2 - 3'
    }
  }
});